import React, { Fragment } from 'react';
import { Card, CardBody, Table, Row } from 'reactstrap';
import { Colxx } from 'Components/CustomBootstrap';
import PropTypes from 'prop-types';
import { Map, List } from 'immutable';
import thousands from 'thousands';
import { Separator } from 'Components/CustomBootstrap';
import FormPromotionTierBenefit from './FormPromotionTierBenefit.jsx';

class PromotionTierBenefit extends React.PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			mode: 'read',
			index: null,
			benefits: props.benefits ? props.benefits : new List(),
		};
		this.onToggleModeHandler = this.onToggleModeHandler.bind(this);
		this.onEditHandler = this.onEditHandler.bind(this);
		this.onCancelHandler = this.onCancelHandler.bind(this);
		this.onClickReOrderUpHandler = this.onClickReOrderUpHandler.bind(this);
		this.onClickReOrderDownHandler = this.onClickReOrderDownHandler.bind(this);
		this.onClickEditHandler = this.onClickEditHandler.bind(this);
		this.onClickDeleteHandler = this.onClickDeleteHandler.bind(this);
		this.onClickAddHandler = this.onClickAddHandler.bind(this);
		this.renderParameters = this.renderParameters.bind(this);
		this.renderErrors = this.renderErrors.bind(this);
	}

	componentDidUpdate(prevProps) {
		const prevBenefits = prevProps.benefits;
		const benefits = this.props.benefits;
		if (benefits !== prevBenefits) {
			this.setState({
				benefits,
			});
		}
	}

	onToggleModeHandler() {
		const { mode } = this.state;
		this.setState({
			mode: mode === 'read' ? 'write' : 'read',
		});
	}

	onEditHandler(benefit) {
		let { index, benefits } = this.state;
		if (index === null) {
			benefits = benefits.push(benefit.set('ordering', benefits.size + 1));
		} else {
			benefits = benefits.set(index, benefit);
		}
		this.props.onChange(benefits);
		this.setState({
			index: null,
			benefits,
		});
	}

	onCancelHandler(e) {
		e.preventDefault();
		const { benefits } = this.props;
		this.setState({
			mode: 'read',
			index: null,
			benefits,
		});
	}

	onClickReOrderUpHandler(e) {
		e.preventDefault();
		let { benefits } = this.state;
		const index = parseInt(e.target.attributes.getNamedItem('data-index').value);
		if (index == 0) {
			return;
		}
		const benefit = benefits.get(index).set('ordering', index);
		const prevBenefit = benefits.get(index - 1).set('ordering', index + 1);
		benefits = benefits
			.set(index - 1, benefit)
			.set(index, prevBenefit)
		;
		this.setState({
			benefits,
		});
		this.props.onChange(benefits);
	}

	onClickReOrderDownHandler(e) {
		e.preventDefault();
		let { benefits } = this.state;
		const index = parseInt(e.target.attributes.getNamedItem('data-index').value);
		if (index == benefits.size - 1) {
			return;
		}
		const benefit = benefits.get(index).set('ordering', index + 2);
		const nextBenefit = benefits.get(index + 1).set('ordering', index + 1);
		benefits = benefits
			.set(index, nextBenefit)
			.set(index + 1, benefit)
		;
		this.setState({
			benefits,
		});
		this.props.onChange(benefits);
	}

	onClickEditHandler(e) {
		e.preventDefault();
		const index = parseInt(e.target.attributes.getNamedItem('data-index').value);
		this.setState({
			index,
		});
	}

	onClickDeleteHandler(e) {
		e.preventDefault();
		if (confirm('Are you sure to delete this benefit?')) {
			const index = parseInt(e.target.attributes.getNamedItem('data-index').value);
			let { benefits } = this.state;
			benefits = benefits.delete(index);
			this.setState({
				benefits,
			});
			this.props.onChange(benefits);
		}
	}

	onClickAddHandler(e) {
		e.preventDefault();
		this.setState({
			index: null,
		});
	}

	renderParameters(benefit) {
		if (benefit.get('apply_criteria_type')) {
			switch (benefit.get('apply_criteria_type').value) {
			case 1: // Item Group
				return benefit.get('parameters').map((parameter, index) => (
					<div key={ `promotion-tier-benefit-parameter-${index}` }>
						{ parameter.label }
					</div>
				));
			case 6: // Coupon Code (Range)
				return `${benefit.get('parameter')} - ${benefit.get('parameterTo')}`;
			default:
				return benefit.get('parameter');
			}
		}
	}

	renderErrors(index, field) {
		let { errors, tierIndex } = this.props;
		const key = `tiers.${tierIndex}.benefits.${index}.${field}`;
		if (errors && errors.detail && errors.detail[key]) {
			errors = errors.detail[key];
			return (
				<div className="text-danger">
					{
						errors.map((error, index) => (
							<Fragment key={ `promotion-tier-benefit-${tierIndex}-${index}-error-${field}` }>
								{ index > 0 && <br /> }
								{ error }
							</Fragment>
						))
					}
				</div>
			);
		}
	}

	render() {
		const { options, tierIndex, defaults, isLoading } = this.props;
		const { mode, index, benefits } = this.state;
		return (
			<Card className="mb-5">
				<CardBody>
					<h3 className="d-block mb-4 text-success">Tier { tierIndex + 1 } Benefits:</h3>
					<Table borderless>
						<thead>
							<tr>
								{ /*
									mode === 'write' && (
										<th width="5%"></th>
									)
								*/ }
								<th width={ mode === 'write' ? '15%' : '20%'}>Benefit</th>
								<th width={ mode === 'write' ? '15%' : '20%'}>Apply To</th>
								<th width="20%">Operator</th>
								<th width="20%">Criteria</th>
								<th width="20%">Parameter</th>
								{
									mode === 'write' && (
										<Fragment>
											<th width="10%"></th>
										</Fragment>
									)
								}
							</tr>
						</thead>
						<tbody>
							{
								benefits.map((benefit, index) => (
									<tr key={ `promotion-tier-benefit-${tierIndex}-${index}` }>
										{ /*
											mode === 'write' && (
												<td>
													<i className="simple-icon-menu cursor-move" />
												</td>
											)
										*/ }
										<td>
											{ benefit.get('type') && benefit.get('type').label }
											{
												benefit.get('number_unit') === '$' ? (
													` $${thousands(benefit.get('number'))}`
												) : (
													` ${thousands(benefit.get('number'))}${benefit.get('number_unit')}`
												)
											}
											{ this.renderErrors(index, 'type') }
											{ this.renderErrors(index, 'number_unit') }
											{ this.renderErrors(index, 'number') }
										</td>
										<td>
											{ benefit.get('apply_to') && benefit.get('apply_to').label }
											{ this.renderErrors(index, 'apply_to') }
										</td>
										<td>
											{ benefit.get('apply_to_operator') && benefit.get('apply_to_operator').label }
											{ this.renderErrors(index, 'apply_to_operator') }
										</td>
										<td>
											{ benefit.get('apply_criteria_type') && benefit.get('apply_criteria_type').label }
											{ this.renderErrors(index, 'apply_criteria_type') }
										</td>
										<td>
											{ this.renderParameters(benefit) }
										</td>
										{
											mode === 'write' && (
												<td className="text-center">
													<i
														className="p-1 cursor-pointer simple-icon-arrow-up"
														data-index={ index }
														onClick={ this.onClickReOrderUpHandler }
													/>
													<i
														className="p-1 cursor-pointer simple-icon-arrow-down"
														data-index={ index }
														onClick={ this.onClickReOrderDownHandler }
													/>
													<i
														className="p-1 cursor-pointer simple-icon-pencil"
														data-index={ index }
														onClick={ this.onClickEditHandler }
													/>
													<i
														className="p-1 cursor-pointer simple-icon-ban"
														data-index={ index }
														onClick={ this.onClickDeleteHandler }
													/>
												</td>
											)
										}
									</tr>
								))
							}
						</tbody>
					</Table>

					{
						mode === 'write' && (
							<Fragment>
								<Separator className="mt-5 my-2" />
								<Row className='my-3'>
									<Colxx xxs="12" className="text-right">
										<button className="btn btn-outline-theme-3 icon-button" onClick={ this.onClickAddHandler }>
											<i className="simple-icon-plus" />
										</button>
									</Colxx>
								</Row>
								<FormPromotionTierBenefit
									options={ options }
									defaults={ defaults }
									isLoading={ isLoading }
									index={ index }
									benefit={ index !== null ? benefits.get(index) : null }
									onEdit={ this.onEditHandler }
									onCancel={ this.onCancelHandler }
								/>
							</Fragment>
						)
					}

					<div className="text-center">
						{
							mode !== 'write' && (
								<Fragment>
									<button className="btn btn-outline-theme-3" onClick={ this.onToggleModeHandler } disabled={ isLoading }>
										<i className="simple-icon-pencil mr-1" />
										Edit
									</button>
								</Fragment>
							)
						}
					</div>
				</CardBody>
			</Card>
		);
	}
}

PromotionTierBenefit.propTypes = {
	tierIndex: PropTypes.number.isRequired,
	options: PropTypes.instanceOf(Map).isRequired,
	errors: PropTypes.object,
	defaults: PropTypes.object.isRequired,
	isLoading: PropTypes.bool.isRequired,
	benefits: PropTypes.instanceOf(List).isRequired,
	onChange: PropTypes.func.isRequired,
};

export default PromotionTierBenefit;